import React from "react";
import { Button, Col, Modal, ModalBody, ModalFooter, Row } from "reactstrap";
import ModalHeader from "@dhn/components/molecules/modal-header";

export default function ModalConfirmRemoveService({
  isOpen,
  handleLoadAppointmetRefetch,
  onChange,
}) {
  const close = () => onChange("isOpenModalRemoveServices", false);

  return (
    <div>
      <Modal isOpen={isOpen} size="sm" centered>
        <ModalHeader
          toggle={close}
          iconClass="fa-trash"
          iconVariant="danger"
          description="Borrar servicio"
          subtitle="Confirme si desea borrar el servicio de la consulta."
        />
        <ModalBody>
          <Row form>
            <Col className="d-flex justify-content-center text-center">
              Al borrar este servicio, se guardará de manera automática. ¿Desea
              seguir con el proceso?
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button
            color="success"
            className="btn-color-success"
            onClick={() => handleLoadAppointmetRefetch()}
          >
            <i className="fa fa-check"></i>
            {" Confirmar"}
          </Button>
          <Button color="danger" className="btn-color-danger" onClick={close}>
            <i className="fa fa-times"></i>
            {" Cancelar"}
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}
